module.exports = __webpack_public_path__ + "img/go3.53c1a9e9.png";